import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query'
import {HTTP_STATUS_OK} from '../../../Constants'
import {
    QueryCRUDTypes,
    QueryKeyManager,
} from '../../../query-manager/QueryKeysManager'
import {QueryKeyTypes} from '../../../query-manager/QueryKeyTypes'
import {severityNotification} from '../../notification/NotificationConstant'
import {showNotification} from '../../notification/NotificationService'
import {createOrUpdateDischarge, getDischargeByUser} from '../DischargeEndPoint'

export const useDischargeCRUD = (type, requestorId) => {
    const {dischargeKeys} = QueryKeyManager(
        QueryKeyTypes.discharge,
        requestorId,
    )
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: data =>
            type === QueryCRUDTypes.create || type === QueryCRUDTypes.update
                ? createOrUpdateDischarge(requestorId, data)
                : data,
        onSuccess: (data, variables) => {
            // Data is the response from the server
            // Variables is the data that was passed to the mutationFn
            if (data === HTTP_STATUS_OK || data?.id) {
                if (
                    type === QueryCRUDTypes.create ||
                    type === QueryCRUDTypes.update
                ) {
                    showNotification(
                        severityNotification.success,
                        'Discharge Information Update Successfully !!',
                    )
                }
            }
        },
    })
}

export const useDischargeByUser = (requestorId, userId, enabled = true) => {
    const {dischargeKeys} = QueryKeyManager(
        QueryKeyTypes.discharge,
        requestorId,
    )
    return useQuery({
        queryKey: dischargeKeys.detailByUser({userId}),
        queryFn: () => getDischargeByUser(requestorId, userId),
        enabled: !!requestorId && !!userId && !!enabled,
    })
}
